export default __webpack_public_path__ + "static/media/FontsFree-Net-SFProText-BoldItalic.a81aaee6.ttf";